import React, {useState, useEffect} from 'react';
import {Button, Form, Grid, Popup} from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import {Actions} from '../../../../common/actions';
import {downloadFile} from '../../../../common/util/file';
import {connect, useSelector, useDispatch} from 'react-redux';
import moment from 'moment';
import {noTimeZoneFullISODate} from '../../../../common/constants/datesFormat';
import {debounce} from 'lodash';

const initialData = {
  'document': '',
  'lastNames': '',
  'names': '',
  'dateFrom': null,
  'dateTo': null,
};

const SearchFloatingInventory = ({
  cleanFloatingAuditScreen,
  fetchAuditFloatingClients,
  fetchFloatingClientsAuditDocument,
  fetchFloatingClientsAuditName,
  fetchFloatingClientsAuditLastName,
  floatingClientList,
  setResetAllFilters,
  setShowFilters,
  showFilters,
  fetchAuditFloatingClientsExcel,
  clearFloatInventoryAudit,
}) => {
  const [data, setData] = useState(initialData);
  const dispatch = useDispatch();
  const dowloadAuditFloatingClientReportWait = useSelector((state) => state.dowloadAuditFloatingClientReportWait);
  const {url} = dowloadAuditFloatingClientReportWait;
  const handleSubmit = (e) => {
    e.preventDefault();
    fetchAuditFloatingClients(data);
  };
  const handleChange = (e, {name, value}) => {
    setData({...data, [name]: value});
  };
  const handleSubmitExcel = (e) => {
    e.preventDefault();
    fetchAuditFloatingClientsExcel(data);
  };
  const handleSelectorChange = (name, value) => {
    setData({...data, [name]: value});
    if (value.length > 2) {
      if (name === 'document') {
        fetchFloatingClientsAuditDocument(name, value);
      } else if (name === 'names') {
        fetchFloatingClientsAuditName(name, value);
      } else if (name === 'lastNames') {
        fetchFloatingClientsAuditLastName(name, value);
      }
    }
  };

  const debouncedHandleSelectorChange = debounce(handleSelectorChange, 600);

  useEffect(() => {
    if (url) {
      downloadFile(url);
      dispatch(clearFloatInventoryAudit());
    }
  }, [url, dispatch, clearFloatInventoryAudit]);

  const handleCleanFilters = () => {
    setData(initialData);
    setResetAllFilters(true);
    cleanFloatingAuditScreen();
  };

  const handleShowFilters = () => {
    setShowFilters(!showFilters);
  };
  return (
    <>
      <Grid
        stackable
        fluid
        className='no-space w-100'
        textAlign='left'
        columns={1}>
        <Grid.Row width={16} columns={6} className='no-space'>
          <Grid.Column width={3}>
            <Form.Select
              label='N° ID:'
              className='selector-tiny-size small-label-custom floating-inventory-full-width'
              placeholder='SELECCIONAR...'
              name='document'
              size='mini'
              search
              value={data.document}
              onChange={handleChange}
              onKeyUp={(e) => debouncedHandleSelectorChange('document', e.target.value)}
              options={floatingClientList?.document?.data}
              loading={floatingClientList?.document?.loading}
              noResultsMessage='No se encontraron resultados...'
            />
          </Grid.Column>
          <Grid.Column width={4}>
            <Form.Select
              label='APELLIDO:'
              className='selector-tiny-size small-label-custom floating-inventory-full-width'
              placeholder='SELECCIONAR...'
              name='lastNames'
              size='mini'
              search
              value={data.lastNames}
              onChange={handleChange}
              onKeyUp={(e) => debouncedHandleSelectorChange('lastNames', e.target.value)}
              options={floatingClientList?.lastNames?.data}
              loading={floatingClientList?.lastNames?.loading}
              noResultsMessage='No se encontraron resultados...'
            />
          </Grid.Column>
          <Grid.Column width={4}>
            <Form.Select
              label='NOMBRE:'
              className='selector-tiny-size small-label-custom floating-inventory-full-width'
              placeholder='SELECCIONAR...'
              name='names'
              size='mini'
              search
              value={data.names}
              onChange={handleChange}
              onKeyUp={(e) => debouncedHandleSelectorChange('names', e.target.value)}
              options={floatingClientList?.names?.data}
              loading={floatingClientList?.names?.loading}
              noResultsMessage='No se encontraron resultados...'
            />
          </Grid.Column>
          <Grid.Column width={1}>
            <span />
          </Grid.Column>
          <Grid.Column width={2}>
            <DatePicker
              name='dateFrom'
              placeholderText='SELECCIONAR...'
              showYearDropdown
              selected={data.dateFrom ? moment(data.dateFrom, noTimeZoneFullISODate).toDate() : null}
              onChange={(value) => handleChange(
                null,
                {
                  'name': 'dateFrom',
                  'value': moment(value).format(noTimeZoneFullISODate),
                }
              )}
              customInput={
                <Form.Input
                  icon='calendar'
                  className='small-label-custom calendar-input-floating floating-inventory-full-width'
                  size='mini'
                  label='DESDE:'
                />
              }
              locale='es'
            />
          </Grid.Column>
          <Grid.Column width={2}>
            <DatePicker
              name='dateTo'
              placeholderText='SELECCIONAR...'
              showYearDropdown
              selected={data.dateTo ? moment(data.dateTo, noTimeZoneFullISODate).toDate() : null}
              onChange={(value) => handleChange(
                null,
                {
                  'name': 'dateTo',
                  'value': moment(value).format(noTimeZoneFullISODate),
                }
              )}
              customInput={
                <Form.Input
                  icon='calendar'
                  className='small-label-custom calendar-input-floating floating-inventory-full-width'
                  size='mini'
                  label='HASTA:'
                  placeholder=' - '
                />
              }
              locale='es'
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <div className='button-section-float-search-card'>
        <Button
          type='button'
          size='mini'
          basic
          compact
          color='grey'
          onClick={handleShowFilters}
        >
          {showFilters ? 'OCULTAR FILTROS DE TABLA' : 'MOSTRAR FILTROS DE TABLA'}
        </Button>
        <Button
          type='button'
          size='mini'
          basic
          compact
          color='grey'
          onClick={handleCleanFilters}
        >
            LIMPIAR FILTROS
        </Button>
        <Popup
          trigger={
            <span>
              <Button
                type='button'
                size='mini'
                compact
                color='grey'
                onClick={handleSubmit}
                primary
                disabled={!data.document && !data.lastNames && !data.names}
              >
                BUSCAR
              </Button>
            </span>
          }
          content={'Ingrese un documento de identificación, nombre o apellido para comenzar la búsqueda.'}
          position='top center'
          size='small'
          style={{'maxWidth': '150px'}}
          inverted
          disabled={data.document || data.lastNames || data.names}
        />
        <Popup
          trigger={
            <span>
              <Button
                type='button'
                size='mini'
                compact
                color='grey'
                onClick={handleSubmitExcel}
                primary
                disabled={!data.document && !data.lastNames && !data.names}
              >
                EXPORTAR
              </Button>
            </span>
          }
          content={'Ingrese un documento de identificación, nombre o apellido para comenzar la búsqueda.'}
          position='top center'
          size='small'
          style={{'maxWidth': '150px'}}
          inverted
          disabled={(data.order && data.line) || data.chassis}
        />
      </div>
    </>
  );
};

const {
  cleanFloatingAuditScreen,
  fetchAuditFloatingClients,
  fetchFloatingClientsAuditDocument,
  fetchFloatingClientsAuditName,
  fetchFloatingClientsAuditLastName,
  fetchAuditFloatingClientsExcel,
  clearFloatInventoryAudit,
} = Actions;

export default connect(null, {
  cleanFloatingAuditScreen,
  fetchAuditFloatingClients,
  fetchFloatingClientsAuditDocument,
  fetchFloatingClientsAuditName,
  fetchFloatingClientsAuditLastName,
  fetchAuditFloatingClientsExcel,
  clearFloatInventoryAudit,
})(SearchFloatingInventory);
